import styled from 'styled-components'
import { pageWidth } from 'shared/lib'

// specs show 1020 as max width for the full page grid content
export const GridContent = styled.div`
  ${pageWidth}
  margin: auto;
`
